<ng-container *ngIf="isBot; else notMine">
  <div
    class="flex flex-row-reverse items-start gap-4"
    *ngIf="message.type === 'interactive'">
    <ng-container *ngIf="message.data.type === 'button'">
      <div
        class="flex flex-col rounded-lg text-white p-2 max-w-xs bg-primary-200 dark:bg-primary-800 dark:bg-opacity-60">
        <div class="flex flex-col">
          <p
            class="text-sm text-text dark:text-contrast"
            [innerHTML]="getFormattedText(message.data.body)"></p>
          <p class="pt-2 text-xs self-end italic text-text dark:text-contrast">
            {{ message.epoch | date: 'dd/MM/YYYY hh:mm a' }}
          </p>
        </div>
        <div class="flex flex-col gap-2 pt-2">
          <div
            class="flow-action-chip"
            *ngFor="let button of message.data!.action!.buttons">
            {{ button.reply.title }}
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="message.data.type === 'flow'">
      <div
        class="flex flex-col rounded-lg text-white p-2 max-w-xs bg-primary-200 dark:bg-primary-800 dark:bg-opacity-60">
        <img
          *ngIf="message.data.header?.image"
          [src]="message.data.header!.image!.link"
          [alt]="renderBodyText(message.data.body)"
          class="w-full h-auto pb-2" />
        <div class="flex flex-col">
          <p
            class="text-sm text-text dark:text-contrast"
            [innerHTML]="getFormattedText(message.data.body)"></p>
          <p class="pt-2 text-xs self-end italic text-text dark:text-contrast">
            {{ message.epoch | date: 'dd/MM/YYYY hh:mm a' }}
          </p>
        </div>
        <div class="flex flex-col gap-2 pt-2">
          <div
            class="flow-action-chip">
            {{ message.data.action!.parameters!.flow_cta }}
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="message.data.type === 'location_request_message'">
      <div
        class="flex flex-col rounded-lg text-white p-2 max-w-xs bg-primary-200 dark:bg-primary-800 dark:bg-opacity-60">
        <div class="flex flex-col">
          <p
            class="text-sm text-text dark:text-contrast"
            [innerHTML]="getFormattedText(message.data.body)"></p>
          <p class="pt-2 text-xs self-end italic text-text dark:text-contrast">
            {{ message.epoch | date: 'dd/MM/YYYY hh:mm a' }}
          </p>
        </div>
        <div class="flex flex-col gap-2 pt-2">
          <div
            class="flow-action-chip flex items-center justify-center gap-2">
            <i class="fa fa-map-marker-alt text-lg"></i>
            <span>Enviar ubicación</span>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="message.data.type === 'list'">
      <div
        class="flex flex-col rounded-lg text-white p-2 max-w-xs bg-primary-200 dark:bg-primary-800 dark:bg-opacity-60">
        <div class="flex flex-col">
          <p
            class="text-sm text-text dark:text-contrast"
            [innerHTML]="getFormattedText(message.data.body)"></p>
          <p class="pt-2 text-xs self-end italic text-text dark:text-contrast">
            {{ message.epoch | date: 'dd/MM/YYYY hh:mm a' }}
          </p>
        </div>
        <div class="flex flex-col gap-2 pt-2">
          <div
            class="flow-action-chip">
            {{ message.data.action!.button }}
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div
    class="flex flex-row-reverse items-start gap-4"
    *ngIf="message.type === 'text'">
    <div
      class="flex flex-col rounded-lg text-white p-2 max-w-xs bg-primary-200 dark:bg-primary-800 bg-opacity-60 break-words">
      <p
        class="text-sm text-text dark:text-contrast"
        [innerHTML]="getFormattedText(message.data.body)"></p>
      <p class="pt-2 text-xs self-end italic text-text dark:text-contrast">
        {{ message.epoch | date: 'dd/MM/YYYY hh:mm a' }}
      </p>
    </div>
  </div>

  <div
    class="flex flex-row-reverse items-start gap-4"
    *ngIf="message.type === 'location'">
    <div
      class="flex flex-col rounded-lg text-white p-2 max-w-xs bg-primary-200 dark:bg-primary-800 bg-opacity-60">
      <div>
        <p class="text-sm flex items-center mb-2 text-text dark:text-contrast">
          Ubicación enviada:
          <a
            [href]="
              'https://www.google.com/maps/?q=' +
              message.data.latitude +
              ',' +
              message.data.longitude
            "
            target="_blank"
            class="ml-2 hover:text-blue-700 flex items-center gap-2 text-text dark:text-contrast">
            <span>Abrir</span>
            <i class="fa fa-map-marker-alt text-lg"></i>
          </a>
        </p>
      </div>
      <p class="pt-2 text-xs self-end italic text-text dark:text-contrast">
        {{ message.epoch | date: 'dd/MM/YYYY hh:mm a' }}
      </p>
    </div>
  </div>

  <div
    class="flex flex-row-reverse items-start gap-4"
    *ngIf="message.type === 'document'">
    <ng-container>
      <div
        class="flex flex-col rounded-lg text-white p-2 max-w-xs bg-primary-200 dark:bg-primary-800 dark:bg-opacity-60">
        <div class="flex flex-col">
          <a [href]="message.data.link" target="_blank">
            <div
              class="flex gap-4 p-4 rounded-lg bg-gray-50 dark:bg-primary-900 mb-2 min-w-72">
              <div class="flex items-center justify-center">
                <app-icon-file></app-icon-file>
              </div>
              <div class="flex flex-col">
                <p class="text-sm text-text dark:text-contrast">
                  {{ message.data.filename }}.{{
                    getFileExtensionFromURI(message.data.link!)
                  }}
                </p>
                <p class="text-xs text-text dark:text-contrast">
                  <strong class="font-semibold">
                    {{
                      getFileExtensionFromURI(message.data.link!).toUpperCase()
                    }}
                  </strong>
                </p>
              </div>
            </div>
          </a>

          <p
            class="text-text text-sm dark:text-contrast mt-2"
            [innerHTML]="getFormattedText(message.data.caption)">
            {{ message.data.caption }}
          </p>
          <p
            class="text-sm text-text dark:text-contrast"
            [innerHTML]="getFormattedText(message.data.body)"></p>
          <p class="pt-2 text-xs self-end italic text-text dark:text-contrast">
            {{ message.epoch | date: 'dd/MM/YYYY hh:mm a' }}
          </p>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>

<ng-template #notMine>
  <ng-container *ngIf="message.type === 'interactive'">
    <ng-container *ngIf="message.data.type === 'button_reply'">
      <div class="flex items-start gap-4">
        <div
          class="reply-bubble">
          <p
            class="text-sm"
            [innerHTML]="
              getFormattedText(message.data.button_reply!.title)
            "></p>
          <p class="pt-2 text-xs self-end italic">
            {{ message.epoch | date: 'dd/MM/YYYY hh:mm a' }}
          </p>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="message.data.type === 'list_reply'">
      <div class="flex items-start gap-4">
        <div
          class="reply-bubble">
          <p
            class="text-sm"
            [innerHTML]="getFormattedText(message.data.list_reply!.title)"></p>
          <p class="pt-2 text-xs self-end italic">
            {{ message.epoch | date: 'dd/MM/YYYY hh:mm a' }}
          </p>
        </div>
      </div>
    </ng-container>

    <app-flow-reply
      *ngIf="message.data.type === 'nfm_reply'"
      [message]="message"></app-flow-reply>
  </ng-container>

  <div class="flex items-start gap-4" *ngIf="message.type === 'text'">
    <div
      class="reply-bubble break-words">
      <p class="text-sm" [innerHTML]="getFormattedText(message.data.body)"></p>
      <p class="pt-2 text-xs self-end italic">
        {{ message.epoch | date: 'dd/MM/YYYY hh:mm a' }}
      </p>
    </div>
  </div>
  <div class="flex items-start gap-4" *ngIf="message.type === 'location'">
    <div
      class="reply-bubble">
      <div class="">
        <p class="text-sm flex items-center mb-2 text-text dark:text-contrast">
          Ubicación recibida:
          <a
            [href]="
              'https://www.google.com/maps/?q=' +
              message.data.latitude +
              ',' +
              message.data.longitude
            "
            target="_blank"
            class="ml-2 hover:text-primary-700 flex items-center gap-2 text-primary-500 dark:text-primary-400">
            <span>Abrir</span>
            <i class="fa fa-map-marker-alt text-lg"></i>
          </a>
        </p>
      </div>
      <p class="pt-2 text-xs self-end italic">
        {{ message.epoch | date: 'dd/MM/YYYY hh:mm a' }}
      </p>
    </div>
  </div>

  <div
    class="w-[360px] flex items-start gap-4"
    *ngIf="message.type === 'image'">
    <div
      class="w-[360px] reply-bubble">
      <div class="p-2 bg-foreground flex items-center gap-2">
        <svg
          width="24"
          height="32"
          viewBox="0 0 24 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            id="Vector"
            d="M0 4C0 1.79063 1.78656 0 3.99093 0H14.3112C15.3713 0 16.3815 0.421438 17.1298 1.17188L22.7795 6.83125C23.5278 7.58125 23.9456 8.59375 23.9456 9.65625V28C23.9456 30.2062 22.1559 32 19.9546 32H3.99093C1.78656 32 0 30.2062 0 28V4ZM20.9524 28V10H15.9637C14.86 10 13.9683 9.10625 13.9683 8V3H3.99093C3.43968 3 2.9932 3.4475 2.9932 4V28C2.9932 28.55 3.43968 29 3.99093 29H19.9546C20.5034 29 20.9524 28.55 20.9524 28Z"
            fill="var(--color-icon-secondary)" />
        </svg>
        <div class="flex flex-col gap-1">
          <span class="text-text"
            >{{ message.data.id }}.{{
              getFileExtension(message.data.mime_type)
            }}</span
          >
          <div class="flex items-center space-x-1">
            <span class="text-text text-sm font-bold">{{
              message.data.mime_type
            }}</span>
            <svg
              *ngIf="sizeFile"
              xmlns="http://www.w3.org/2000/svg"
              width="6"
              height="6"
              viewBox="0 0 6 6"
              fill="none">
              <circle cx="3.44531" cy="3" r="2.5" fill="var(--color-icon-default)" />
            </svg>
            <span class="text-text text-sm font-bold">{{ sizeFile }}</span>
          </div>
        </div>
      </div>

      <div class="flex items-center gap-2 p-1">
        <div
          class="w-full h-8 p-2.5 bg-background-button-action rounded-md justify-center items-center gap-1.5 inline-flex hover:cursor-pointer"
          (click)="downloadImage()">
          <svg
            class="fill-current"
            width="18"
            height="12"
            viewBox="0 0 18 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              id="Vector"
              d="M6.40193 7.50268C6.15282 7.275 6.15282 6.86786 6.40193 6.61607C6.65371 6.36696 7.06085 6.36696 7.28853 6.61607L8.35728 7.66339V4.07143C8.35728 3.71518 8.64389 3.42857 9.00014 3.42857C9.35639 3.42857 9.643 3.71518 9.643 4.07143V7.66339L10.6876 6.61607C10.9394 6.36696 11.3466 6.36696 11.5742 6.61607C11.8475 6.86786 11.8475 7.275 11.5742 7.50268L9.43139 9.64554C9.20371 9.91875 8.79657 9.91875 8.54478 9.64554L6.40193 7.50268ZM4.28585 12C2.15559 12 0.428711 10.2723 0.428711 8.14286C0.428711 6.46339 1.50201 5.01161 3.00014 4.50536V4.5C3.00014 2.01429 5.01442 0 7.50014 0C8.86353 0 10.0823 0.605357 10.91 1.56187C11.3091 1.38429 11.7484 1.28571 12.2144 1.28571C13.9903 1.28571 15.4287 2.72411 15.4287 4.5C15.4287 4.67679 15.4153 4.84821 15.3885 5.01696C16.6742 5.57946 17.5716 6.86518 17.5716 8.35714C17.5716 10.2964 16.0555 11.8821 14.143 11.9946V12H4.28585ZM7.50014 1.28571C5.72425 1.28571 4.28585 2.72411 4.28585 4.5V5.41339L3.4046 5.71875C2.428 6.07232 1.71443 7.02589 1.71443 8.14286C1.71443 9.5625 2.86567 10.7143 4.28585 10.7143H13.9984L14.068 10.7089C15.3055 10.6393 16.2859 9.61071 16.2859 8.35714C16.2859 7.39286 15.7073 6.55982 14.8716 6.19554L13.9582 5.79643L14.1189 4.81339C14.135 4.71161 14.143 4.60714 14.143 4.5C14.143 3.43393 13.2805 2.57143 12.2144 2.57143C11.9332 2.57143 11.668 2.63036 11.4323 2.7375L10.5591 3.12589L9.93496 2.40268C9.343 1.71643 8.47246 1.28571 7.47603 1.28571H7.50014Z" />
          </svg>
          <button
            class="text-sm text-text dark:text-white leading-none"
            [disabled]="isLoadingDownloadButton">
            <div class="leading-none" *ngIf="!isLoadingDownloadButton">
              Descargar
            </div>
            <div *ngIf="isLoadingDownloadButton">Descargando...</div>
          </button>
        </div>
        <div
          class="w-full h-8 p-2.5 rounded-md border border-primary-400 justify-center items-center gap-1.5 inline-flex hover:cursor-pointer"
          (click)="openModal(message)">
          <svg
            *ngIf="isDarkMode()"
            class="fill-current"
            width="16"
            height="12"
            viewBox="0 0 16 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              id="Vector"
              d="M4.57185 6C4.57185 4.10625 6.10667 2.57143 8.00042 2.57143C9.89417 2.57143 11.429 4.10625 11.429 6C11.429 7.89375 9.89417 9.42857 8.00042 9.42857C6.10667 9.42857 4.57185 7.89375 4.57185 6ZM8.00042 8.14286C9.18435 8.14286 10.1433 7.18393 10.1433 6C10.1433 4.81607 9.18435 3.85714 8.00042 3.85714C7.98167 3.85714 7.9656 3.85714 7.92274 3.85714C7.98167 3.99375 8.00042 4.13839 8.00042 4.28571C8.00042 5.23125 7.23167 6 6.28614 6C6.13881 6 5.99417 5.98125 5.85756 5.92232C5.85756 5.96518 5.85756 5.98125 5.85756 5.97589C5.85756 7.18393 6.81649 8.14286 8.00042 8.14286ZM2.84203 2.15893C4.1031 0.986786 5.83614 0 8.00042 0C10.1647 0 11.8977 0.986786 13.1594 2.15893C14.4129 3.32143 15.2513 4.69018 15.6477 5.67054C15.7361 5.88214 15.7361 6.11786 15.6477 6.32946C15.2513 7.28571 14.4129 8.65446 13.1594 9.84107C11.8977 11.0143 10.1647 12 8.00042 12C5.83614 12 4.1031 11.0143 2.84203 9.84107C1.58846 8.65446 0.7506 7.28571 0.352056 6.32946C0.264158 6.11786 0.264158 5.88214 0.352056 5.67054C0.7506 4.69018 1.58846 3.32143 2.84203 2.15893ZM8.00042 1.28571C6.25399 1.28571 4.81828 2.07857 3.71739 3.09911C2.68614 4.05804 1.97417 5.17232 1.61042 6C1.97417 6.80357 2.68614 7.94196 3.71739 8.90089C4.81828 9.92143 6.25399 10.7143 8.00042 10.7143C9.74685 10.7143 11.1826 9.92143 12.2835 8.90089C13.3147 7.94196 14.0031 6.80357 14.3915 6C14.0031 5.17232 13.3147 4.05804 12.2835 3.09911C11.1826 2.07857 9.74685 1.28571 8.00042 1.28571Z"
              fill="#aef2c1" />
          </svg>
          <svg
            *ngIf="!isDarkMode()"
            class="fill-current"
            width="16"
            height="12"
            viewBox="0 0 16 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              id="Vector"
              d="M4.57185 6C4.57185 4.10625 6.10667 2.57143 8.00042 2.57143C9.89417 2.57143 11.429 4.10625 11.429 6C11.429 7.89375 9.89417 9.42857 8.00042 9.42857C6.10667 9.42857 4.57185 7.89375 4.57185 6ZM8.00042 8.14286C9.18435 8.14286 10.1433 7.18393 10.1433 6C10.1433 4.81607 9.18435 3.85714 8.00042 3.85714C7.98167 3.85714 7.9656 3.85714 7.92274 3.85714C7.98167 3.99375 8.00042 4.13839 8.00042 4.28571C8.00042 5.23125 7.23167 6 6.28614 6C6.13881 6 5.99417 5.98125 5.85756 5.92232C5.85756 5.96518 5.85756 5.98125 5.85756 5.97589C5.85756 7.18393 6.81649 8.14286 8.00042 8.14286ZM2.84203 2.15893C4.1031 0.986786 5.83614 0 8.00042 0C10.1647 0 11.8977 0.986786 13.1594 2.15893C14.4129 3.32143 15.2513 4.69018 15.6477 5.67054C15.7361 5.88214 15.7361 6.11786 15.6477 6.32946C15.2513 7.28571 14.4129 8.65446 13.1594 9.84107C11.8977 11.0143 10.1647 12 8.00042 12C5.83614 12 4.1031 11.0143 2.84203 9.84107C1.58846 8.65446 0.7506 7.28571 0.352056 6.32946C0.264158 6.11786 0.264158 5.88214 0.352056 5.67054C0.7506 4.69018 1.58846 3.32143 2.84203 2.15893ZM8.00042 1.28571C6.25399 1.28571 4.81828 2.07857 3.71739 3.09911C2.68614 4.05804 1.97417 5.17232 1.61042 6C1.97417 6.80357 2.68614 7.94196 3.71739 8.90089C4.81828 9.92143 6.25399 10.7143 8.00042 10.7143C9.74685 10.7143 11.1826 9.92143 12.2835 8.90089C13.3147 7.94196 14.0031 6.80357 14.3915 6C14.0031 5.17232 13.3147 4.05804 12.2835 3.09911C11.1826 2.07857 9.74685 1.28571 8.00042 1.28571Z"
              fill="#449e62" />
          </svg>
          <button
            class="text-primary-800 dark:text-primary-300 text-sm leading-none">
            Ver Imagen
          </button>
        </div>
      </div>
      <p class="pt-2 text-xs self-end italic">
        {{ message.epoch | date: 'dd/MM/YYYY hh:mm a' }}
      </p>
    </div>
  </div>

  <div
    *ngIf="message.type === 'document'"
    class="reply-bubble">
    <div class="flex flex-col">
      <a [href]="message.data.link" target="_blank">
        <div
          class="flex gap-4 p-4 rounded-lg bg-gray-100 dark:bg-foreground mb-2 min-w-72">
          <div class="flex items-center justify-center">
            <app-icon-file></app-icon-file>
          </div>
          <div class="flex flex-col">
            <p class="text-sm text-text dark:text-contrast">
              {{ message.data.filename }}.{{
                getFileExtensionFromURI(message.data.link!)
              }}
            </p>
            <p class="text-xs text-text dark:text-contrast">
              <strong class="font-semibold">
                {{ getFileExtensionFromURI(message.data.link!).toUpperCase() }}
              </strong>
            </p>
          </div>
        </div>
      </a>

      <p
        class="text-text text-sm dark:text-contrast mt-2"
        [innerHTML]="getFormattedText(message.data.caption)">
        {{ message.data.caption }}
      </p>
      <p
        class="text-sm text-text dark:text-contrast"
        [innerHTML]="getFormattedText(message.data.body)"></p>
      <p class="pt-2 text-xs self-end italic text-text dark:text-contrast">
        {{ message.epoch | date: 'dd/MM/YYYY hh:mm a' }}
      </p>
    </div>
  </div>

  <app-image-modal
    *ngIf="isModalOpen"
    [isModalOpen]="isModalOpen"
    [selectedConversation]="selectedConversation"
    [message]="MessageImageData"
    (close)="closeModal()"></app-image-modal>
</ng-template>
